import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";
import type {CustomerModel} from "../Models/CustomerModel";
import type {CompanyModel} from "../Models/CompanyModel";
import type {GuestModel} from "../Models/GuestModel";
import type {PaymentMethods} from "../Models/PaymentMethods";

/**
 * Wiadomość, gdy zmieniono dane klienta, do service workera,
 * lub z service workera (gdy jakiś komponent się zapisze na otrzymywanie tych aktualizacji)
 */
export class SetCustomerData extends NfComponentGlobalMessage {
    public customerData= {} as CustomerModel;
    public invoiceData= undefined as CompanyModel|undefined;
    public comment= '' as string|undefined;
    public paymentMethod= null as PaymentMethods | null;
    public persistentMessage = true;
    public constructor(sourceComponentId: number |MessageEvent<SetCustomerData>,customerData?: CustomerModel,
                       invoiceData?:CompanyModel, comment?: string, paymentMethod?: PaymentMethods | null) {
        super(NfMessageType.SetCustomerData, arguments.length > 1);
        if(NfMessage.isMessageEvent(sourceComponentId)) {
            Object.assign(this, sourceComponentId.data);
        } else {
            this.sourceComponentId = sourceComponentId as number;
            if(!customerData) {
                throw Error('customerData is required');
            }
            this.customerData = customerData;
            this.invoiceData = invoiceData;
            if(!paymentMethod) {
                throw Error('paymentMethod is required');
            }
            this.paymentMethod = paymentMethod;
            this.comment = comment;
        }
    }
}
NfMessage.creationCallbacks[NfMessageType.SetCustomerData] = (event) => {
    return new SetCustomerData(event);
}
